<template>
  <div class="page-content">
    <TripRequestPageHeading
      @filterData="filterData"
      pageName="backup-request"
      :filterOptions="[
        { name: 'Backup Request Code', value: 'backup_request_code' }
      ]"
    ></TripRequestPageHeading>
    <div class="card text-center mt-3">
      <div class="card-body">
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <template v-else-if="this.trips.length > 0">
          <div class="row">
            <div class="col-md-12">
              <select
                v-model="perPage"
                class="form-select form-select-sm"
                style="width: 90px; float: left"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
              <button
                v-if="selectedTR.length > 0"
                class="btn btn-sm btn-primary"
                style="float: right"
                @click="selectBackupRoutes()"
              >
                Search Drivers
              </button>
            </div>
          </div>
          <div class="mt-3">
            <div class="table-responsive">
              <table class="table table-hover table-bordered" id="datatable">
                <thead class="table-light">
                  <tr>
                    <th>
                      <input
                        v-if="showSelectAllCheckbox"
                        type="checkbox"
                        v-model="selectAllTR"
                        class="form-check-input"
                      />
                    </th>
                    <th>Id</th>
                    <th>Route</th>
                    <th>Service Type</th>
                    <th>Backup Requested</th>
                    <th>Trip Time</th>
                    <th>Existing Driver</th>
                    <th>Backup Driver</th>
                    <th>Action</th>
                    <th>Invited</th>
                    <th>Accepted</th>
                    <th>Assigned</th>
                    <th>Assigned By</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="trip in trips" :key="trip.id">
                    <td>
                      <input
                        type="checkbox"
                        v-if="
                          trip.trip_request_id &&
                          trip.backup_status !== 'Assigned' &&
                          trip.backup_status !== 'Cancelled' &&
                          trip.backup_status !== 'Completed'
                        "
                        v-model="TRSelectStatus[trip.id]"
                        class="form-check-input"
                      />
                    </td>
                    <td>{{ trip.backup_request_code }}</td>
                    <td>
                      <router-link
                        v-if="trip.trip_request_id"
                        :to="`/trip-request/backup/details/${trip.id}/${trip.route_id}`"
                        >{{ trip.route_name }}
                      </router-link>
                      <span v-else
                        >{{ trip.route_name }}
                        <span class="text-danger"> (TR not found!) </span>
                      </span>
                    </td>
                    <td>{{ trip.service_type }}</td>
                    <td>{{ trip.created_at }}</td>
                    <td>{{ trip.backup_time }}</td>
                    <td>
                      {{
                        driverDetails.find(
                          (driver) => driver.user_code === trip.old_driver_code
                        )
                          ? driverDetails.find(
                              (driver) =>
                                driver.user_code === trip.old_driver_code
                            ).name
                          : 'No Name Found'
                      }}
                    </td>
                    <td>
                      <span v-if="getAssignedDriverCodeFromTrip(trip)">
                        {{
                          driverDetails.find(
                            (driver) =>
                              driver.user_code ===
                              getAssignedDriverCodeFromTrip(trip)
                          )
                            ? driverDetails.find(
                                (driver) =>
                                  driver.user_code ===
                                  getAssignedDriverCodeFromTrip(trip)
                              ).name
                            : 'No Name Found'
                        }}
                      </span>
                      <span v-else>N/A</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-xs btn-primary mb-1"
                        style="margin-right: 5px"
                        v-if="
                          trip.backup_status !== 'Assigned' &&
                          trip.backup_status !== 'Cancelled' &&
                          trip.backup_status !== 'Completed'
                        "
                        @click="selectedTrip = trip"
                        data-bs-toggle="modal"
                        data-bs-target="#assignDriverToBackupTripModal"
                      >
                        Assign Driver
                      </button>
                      <button
                        v-if="
                          trip.backup_status !== 'Assigned' &&
                          trip.backup_status !== 'Cancelled' &&
                          trip.backup_status !== 'Completed' &&
                          !trip.trip_request_id
                        "
                        class="btn btn-xs btn-primary mb-1"
                        @click="selectSingleBackupRoutes(trip)"
                      >
                        Search Drivers
                      </button>
                      <button
                        v-if="trip.backupHistory?.length > 0"
                        class="btn btn-xs btn-warning mb-1"
                        @click="
                          selectedTrip = trip;
                          backupHistory = trip.backupHistory;
                        "
                        data-bs-toggle="modal"
                        data-bs-target="#backupHistoryModal"
                      >
                        <i class="bi bi-clock-history"></i>
                      </button>
                    </td>
                    <td>{{ trip.invitedCount }}</td>
                    <td>{{ trip.acceptedCount }}</td>
                    <td>{{ trip.assignedCount }}</td>
                    <td>
                      <span v-if="trip.assign_by">{{
                        driverDetails.find(
                          (driver) => driver.user_code === trip.assign_by
                        )
                          ? driverDetails.find(
                              (driver) => driver.user_code === trip.assign_by
                            ).name
                          : 'No Name Found'
                      }}</span>
                      <span v-else>N/A</span>
                    </td>
                    <td>
                      <b
                        :class="{
                          'text-success': trip.backup_status === 'Assigned',
                          'text-warning': trip.backup_status === 'Pending',
                          'text-danger': trip.backup_status === 'Cancelled',
                          'text-info': trip.backup_status === 'Completed'
                        }"
                        >{{ trip.backup_status }}</b
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Paginate -->
          <div class="row">
            <div class="col-md-12">
              <p style="float: left">
                Showing {{ this.from }}-{{ this.to }} out of {{ this.total }}
              </p>
              <paginate
                :totalPages="totalPages"
                :total="total"
                :currentPage="currentPage"
                :perPage="perPage"
                v-on:pagechanged="getAllData"
              ></paginate>
            </div>
          </div>
        </template>
        <NoDataMessage v-else></NoDataMessage>
      </div>
    </div>
  </div>
  <!-- Assign Driver To Backup Modal -->
  <teleport to="body">
    <div
      class="modal fade"
      id="assignDriverToBackupTripModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <AssignDriverToBackupTrip
          :backupTrip="selectedTrip"
          @refreshData="getAllData()"
        ></AssignDriverToBackupTrip>
      </div>
    </div>
  </teleport>
  <!-- Backup History Modal -->
  <teleport to="body">
    <div
      class="modal partner-modal fade"
      id="backupHistoryModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xxxl">
        <BackupHistory
          :backupTrip="selectedTrip"
          :backupHistory="backupHistory"
        ></BackupHistory>
      </div>
    </div>
  </teleport>
</template>

<script>
import Paginate from '../pagination/Pagination.vue';
import http from '../../config/axios';
import userService from '../../config/axiosUserService';
import TripRequestPageHeading from './TripRequestPageHeading.vue';
import AssignDriverToBackupTrip from './AssignDriverToBackupTrip.vue';
import BackupHistory from '../tripDetails/BackupHistory.vue';
import { backupRequest } from '../../store/backupRequest/backupRequest';

export default {
  name: 'BackupTrip',
  props: ['swal'],
  components: {
    Paginate,
    // Loader,
    TripRequestPageHeading,
    AssignDriverToBackupTrip,
    BackupHistory
  },
  mounted() {
    this.getAllData();
    // this.searchData();
    this.permission = localStorage.getItem('userPermission').split(',');
  },
  data() {
    return {
      trips: [],
      tripsByKey: {},
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 10,
      pageCount: '',
      to: 0,
      from: 0,
      global_search: '',
      service_type: '',
      isLoading: true,
      trip_request_status: '',
      permission: '',
      filterValues: {
        backup_request_code: '',
        start_date: '',
        end_date: '',
        service_type: ''
      },
      selectAllTR: false,
      TRSelectStatus: {},
      selectedTR: [],
      driverDetails: [],
      selectedTrip: {},
      backupHistory: [],
      backupRequest
    };
  },
  watch: {
    perPage: function () {
      this.getAllData();
    },
    selectAllTR: function () {
      for (const key in this.TRSelectStatus) {
        this.TRSelectStatus[key] = this.selectAllTR;
      }
    },
    TRSelectStatus: {
      handler() {
        this.selectedTR = [];
        for (const key in this.TRSelectStatus) {
          if (
            this.TRSelectStatus[key] &&
            this.tripsByKey[key].trip_request_id &&
            this.tripsByKey[key].backup_status !== 'Assigned'
          ) {
            let price = backupRequest.calculatePriceFromTripRequest(
              this.tripsByKey[key].tripRequestRoute
                ? this.tripsByKey[key].tripRequestRoute
                : this.tripsByKey[key].tripRequest
            );
            this.selectedTR.push({
              id: key,
              trip_id: this.tripsByKey[key].trip_id,
              trip_request_id: this.tripsByKey[key].trip_request_id,
              backup_request_code: this.tripsByKey[key].backup_request_code,
              route_name: this.tripsByKey[key].route_name,
              price: price
            });
          }
        }
      },
      deep: true
    }
  },
  computed: {
    showSelectAllCheckbox() {
      let show = false;
      this.trips.forEach((trip) => {
        if (
          trip.trip_request_id &&
          trip.backup_status !== 'Assigned' &&
          trip.backup_status !== 'Cancelled' &&
          trip.backup_status !== 'Completed'
        ) {
          show = true;
        }
      });
      return show;
    }
  },
  methods: {
    mapKeyWiseTrip() {
      this.tripsByKey = {};
      this.trips.forEach((item) => {
        this.tripsByKey[item.id] = item;
      });
    },
    mapTRSelectStatus() {
      this.TRSelectStatus = {};
      this.trips.forEach((item) => {
        this.TRSelectStatus[item.id] = false;
      });
    },
    getAssignedDriverCodeFromTrip(trip) {
      let assignedDriverCode = null;

      if (trip.inviteDrivers && trip.inviteDrivers.length > 0) {
        trip.inviteDrivers.forEach((driver) => {
          if (driver.status === 'Assigned') {
            assignedDriverCode = driver.partner_id;
          }
        });
      }

      return assignedDriverCode;
    },
    getAllAssignedDriverCodesFromTrips() {
      let driverCodes = [];
      this.trips.forEach((trip) => {
        let assignedDriverCode = this.getAssignedDriverCodeFromTrip(trip);
        if (assignedDriverCode) {
          driverCodes.push(assignedDriverCode);
        }
      });
      return driverCodes;
    },
    getDriverDetails(id, callback) {
      userService
        .get(
          `v1/users?user_code=${id.join(
            ','
          )}&fields=name,mobile,user_code,email,status,role&limit=500`
        )
        .then((response) => {
          this.driverDetails = response.data.data;
          callback();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllData(value) {
      this.isLoading = true;
      http
        .get(
          //   `/v2/partners/backup/request?trip_request_id=''&backup_request_code=''&start_date=''&end_date=''&trip_code=''&trip_types_id=''`
          `/v2/partners/backup/request?page=${value}&perPage=${this.perPage}&trip_types_id=${this.filterValues.service_type}&backup_request_code=${this.filterValues.backup_request_code}&start_date=${this.filterValues.start_date}&end_date=${this.filterValues.end_date}`
        )
        .then((response) => {
          this.trips = response.data.data;
          this.total = response.data.meta.total;
          this.totalPages = response.data.meta.last_page;
          this.currentPage = response.data.meta.current_page;
          this.perPage = response.data.meta.per_page;
          this.to = response.data.meta.to;
          this.from = response.data.meta.from;
          this.mapKeyWiseTrip();
          this.mapTRSelectStatus();
          let userCodes = this.trips.map((trip) => trip.old_driver_code);
          let assignedDrivers = this.getAllAssignedDriverCodesFromTrips();
          let assignedByUserCodes = this.trips.map((trip) => trip.assign_by);
          this.getDriverDetails(
            [...userCodes, ...assignedDrivers, ...assignedByUserCodes],
            () => {
              this.isLoading = false;
            }
          );
        });
    },
    filterData(filterValues) {
      this.filterValues.service_type = filterValues.service_type;
      this.filterValues.backup_request_code = filterValues.backup_request_code;
      this.filterValues.start_date = filterValues.start_date;
      this.filterValues.end_date = filterValues.end_date;
      this.getAllData();
    },
    selectBackupRoutes() {
      localStorage.setItem('selectedBackupTR', JSON.stringify(this.selectedTR));
      this.$router.push('/trip-request/partner-location-list');
    },
    selectSingleBackupRoutes(trip) {
      let price = backupRequest.calculatePriceFromTripRequest(
        trip.tripRequestRoute ? trip.tripRequestRoute : trip.tripRequest
      );
      let selectedTR = [
        {
          id: trip.id,
          trip_id: trip.trip_id,
          trip_request_id: trip.trip_request_id,
          backup_request_code: trip.backup_request_code,
          route_name: trip.route_name,
          price: price
        }
      ];
      localStorage.setItem('selectedBackupTR', JSON.stringify(selectedTR));
      this.$router.push('/trip-request/partner-location-list');
    }
  }
};
</script>

<style scoped>
.table {
  font-size: 13px;
  font-style: normal;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

#searchButton {
  background: #1c2457;
}

#searchButton:hover,
#searchButton:focus,
#searchButton:active {
  background: #1c2457;
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .dataTables_filter,
  .dataTables_info {
    display: none;
  }

  .filter-style {
    text-align: center;
  }

  .dropdown {
    text-align: end;
  }
}
</style>
